
import CircleInfo from "@dana/Icons/CircleInfo";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import { IconMemo } from "@insite/mobius/Icon";
import Typography from "@insite/mobius/Typography";
import React from "react";


type Props = HasProductContext;
const MultipleSaleQtyMessage = ({
  productContext: {
    product: { id: productId, detail },
  }
}: Props) => {

  const soldQty = detail?.multipleSaleQty;

  if (!soldQty || soldQty <= 0) {
    return null;
  }

  let message = siteMessage("ProductDetailPage_SoldPkgQty_Message");
  if (message) {
    message = message.toString().replace("{0}", soldQty.toString());
  }

  return (
    <Typography className="info-message-box">
      <IconMemo size={13} src={CircleInfo} /> {message}
    </Typography>
  );
};
export default withProductContext(MultipleSaleQtyMessage);

